/**
 * Modalità di visualizzazione corrente dell'app:
 *   - 'standalone' se gira come PWA installata (display-mode standalone, oppure
 *     `navigator.standalone` su iOS Safari, che non supporta la media query)
 *   - 'browser' altrimenti (scheda browser normale)
 *
 * È l'UNICO segnale che distingue "PWA installata" da "browser": lo User-Agent
 * NON lo espone. Viene inviato al ping pubblico come header `X-Display-Mode`
 * per il breakdown dispositivi (vedi lib/api.js → publicApi.presence.ping).
 *
 * Calcolato per-chiamata (costo trascurabile) così da cogliere anche la
 * transizione install/launch a metà sessione.
 */
export function getDisplayMode () {
  const standalone = typeof window !== 'undefined' &&
    (window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true)
  return standalone ? 'standalone' : 'browser'
}
